export function getNextSelectedObject(
  objectsIds: number[],
  selectedId: number,
  direction: 'forward' | 'backward',
) {
  const newIndex =
    objectsIds.indexOf(selectedId) + (direction === 'forward' ? 1 : -1);
  return objectsIds.at(newIndex % objectsIds.length)!;
}
